
















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { BASE_API_URL } from "../../utils/Constants";

@Component
export default class VSignPost extends Vue {
  @Prop({ default: "" }) readonly path!: string;
  underlinedPath = "";

  @Watch("path")
  onPathChanged(value: string) {
    this.underlinedPath = VSignPost.removeHeadingBackSlash(value);
  }

  get imagePath() {
    return `url('${this.underlinedPath}')`;
  }

  mounted() {
    this.underlinedPath = VSignPost.removeHeadingBackSlash(this.path);
  }

  notifyEdit() {
    this.$emit("upload");
  }

  static removeHeadingBackSlash(url: string) {
    if (url && url[0] === "/") {
      const apiUrl = BASE_API_URL;
      const host = apiUrl.substring(0, apiUrl.length - 3);
      return `${host}${url.substring(1)}`;
    }
    return url;
  }
}
